import type { FaireProductEntity } from "../../entity_types/product";

export const p_acjh7nsnea: FaireProductEntity = {
  token: "p_acjh7nsnea",
  type: "product",
  name: "Antique Finish Rhinestone Bohemian Dangle Earrings",
  brandToken: "b_nnzc8s53xn",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/808b46c4d27de7e90e8bd735183698973e33aa285556526dccab3fdaf8ba41b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1086537d6657e89bb6a1188041dc7259a5b784a318578899a9cbba424635bce.jpeg",
    "https://cdn.faire.com/fastly/ff40104b680945bba7b9c58c4d7111ae679958f35d18a58bcf53eaa005cc61e0.jpeg",
  ],
  priceDollars: 11.25,
  description:
    '* Approx. 3" in length \n\nThese Antique Finish Rhinestone Bohemian Dangle Earrings add a touch of vintage elegance to any outfit. With their antique finish and sparkling rhinestones, they are the perfect accessory for a bohemian-inspired look. Made to last, these earrings are a must-have for any fashion-forward individual.',
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:08.700Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
